/**
 * @generated SignedSource<<cda12115a2d6c536afef7922d8670c4e>>
 * @relayHash 85b048c98f58c3903ed23f74fbf507f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 64ce200dcf2252808b6f2534a27984730b37ac99ba9eb4c6faef6129ab071331

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestoreContentModalRestoreContentMutation$variables = {
  restoreVersionContentId: string;
  spaceKey: string;
  title?: string | null | undefined;
  type: string;
};
export type RestoreContentModalRestoreContentMutation$data = {
  readonly createContentContextual: {
    readonly id: string | null | undefined;
    readonly links: {
      readonly context: string | null | undefined;
      readonly webui: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RestoreContentModalRestoreContentMutation = {
  response: RestoreContentModalRestoreContentMutation$data;
  variables: RestoreContentModalRestoreContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restoreVersionContentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "args": [
      {
        "fields": [
          {
            "items": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "restoreVersionContentId"
                  },
                  {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "restoreVersionContentId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "contentSpecificCreateInput.0"
              }
            ],
            "kind": "ListValue",
            "name": "contentSpecificCreateInput"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Literal",
            "name": "status",
            "value": "CURRENT"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentContextual",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "context"
          },
          {
            "kind": "ScalarField",
            "name": "webui"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RestoreContentModalRestoreContentMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "RestoreContentModalRestoreContentMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "85b048c98f58c3903ed23f74fbf507f8",
    "id": "64ce200dcf2252808b6f2534a27984730b37ac99ba9eb4c6faef6129ab071331",
    "metadata": {},
    "name": "RestoreContentModalRestoreContentMutation",
    "operationKind": "mutation",
    "text": "mutation RestoreContentModalRestoreContentMutation($spaceKey:String!,$restoreVersionContentId:String!,$title:String,$type:String!){createContentContextual(input:{spaceKey:$spaceKey,contentSpecificCreateInput:[{key:\"restoreVersionContentId\",value:$restoreVersionContentId}],status:CURRENT,title:$title,type:$type}){id,links{context,webui}}}"
  }
};
})();

(node as any).hash = "7802992675fb7028e2a9b80023fd6854";

export default node;
